import { render, staticRenderFns } from "./wizardTrainingAssesment.vue?vue&type=template&id=e1a5fbb2&scoped=true"
import script from "./wizardTrainingAssesment.vue?vue&type=script&lang=js"
export * from "./wizardTrainingAssesment.vue?vue&type=script&lang=js"
import style0 from "./wizardTrainingAssesment.vue?vue&type=style&index=0&id=e1a5fbb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a5fbb2",
  null
  
)

export default component.exports